import Localization from "@localization/Index"
import { toastSuccess } from "@utils/NotificationsUtils"

type ClipboardType = {
    text: string,
    textSuccess?: string,
    showToast?: boolean
}

/**
 * copy the text to the clipboard
 * @param args of type ClipboardType
 * @returns 
 */
const copyToClipboard = async (args:ClipboardType) =>{
    const {text, textSuccess=Localization.COPIATO, showToast=true } = args
    if(navigator.clipboard) {
        await navigator.clipboard.writeText(text)
    } else {
        const input = document.createElement('textarea')
        input.value = text
        document.body.appendChild(input)
        input.select()
        document.execCommand('copy')
        document.body.removeChild(input)
    }
    showToast && toastSuccess(textSuccess)
    return
}

/**
 * generate random id
 * @returns the id generated
 */
const generateId = ():string=>{
    return Math.floor(Math.random() * Date.now()).toString(16)
}

type HighlightProps = {
    fullText: string
    searchTerm: string
    contextBefore: number
    contextAfter: number
}

export const HighlightedText: React.FC<HighlightProps> = ({
    fullText,
    searchTerm,
    contextBefore,
    contextAfter,
}) => {
    const index = fullText.toLowerCase().indexOf(searchTerm.toLowerCase());

    if (index === -1) {
        return <div>Testo non trovato</div>;
    }

    const start = Math.max(0, index - contextBefore);
    const end = Math.min(fullText.length, index + searchTerm.length + contextAfter);

    const before = fullText.slice(start, index);
    const match = fullText.slice(index, index + searchTerm.length);
    const after = fullText.slice(index + searchTerm.length, end);

    return (
        <div>
            ...
            {before}
            <span className="bg-warning">{match}</span>
            {after}
            ...
        </div>
    );
};

const readFileAsText = (file: File): Promise<string> => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();

        reader.onload = () => {
            resolve(reader.result as string);
        };

        reader.onerror = () => {
            reject(reader.error);
        };

        reader.readAsText(file);
    });
};

export { copyToClipboard, generateId, readFileAsText }